var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contained-example-container" }, [
      _c(
        "div",
        {
          staticClass: "vs-con-loading__container text-center text-danger",
          attrs: { id: "div-with-loading" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "con-vs-loading vs-loading-background-undefined vs-loading-color-undefined",
            },
            [
              _c(
                "div",
                {
                  staticClass: "vs-loading default",
                  staticStyle: { transform: "scale(0.6)" },
                },
                [
                  _c("div", { staticClass: "effect-1 effects" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "effect-2 effects" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "effect-3 effects" }),
                  _vm._v(" "),
                  _c("img", { attrs: { src: "" } }),
                ]
              ),
            ]
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }